import React, { useState } from "react";
import { useStandard } from "../../../context/StandardContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ViewTableIndex from "../../../components/View/ViewTableIndex";
import UseGetData from "../../../hooks/useFetchData";
import { PaperClip } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";
import useGetStatusData from "../../../hooks/useGetStatusData";
import CreateOrEdit from "./from";
import ViewMore from "./viewMore";
import CommonXlsExport from "../../../utils/CommonXlsExport";
import useGetStandardDetail from "../../../hooks/useGetStandardDetail";
import CommonImport from "../../../utils/CommonImport";
import useGetDropDown from "../../../hooks/useFetchDropDown";


function AuditScheduleIndex() {
  const ModelId = 6;
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  let { statusFilter } = location?.state || "";
  const { statusValue } = useGetStatusData({ value: ModelId });
  const { dropDownValue } = useGetDropDown({
    url: `/Frequency/`,
    value: "frequency_type",
  });
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const { data, totalCount, getData, isLoading } = UseGetData({
    url: statusFilter
      ? `/Audit-Schedule/standard/${stdId}/status/${statusFilter}`
      : `/Audit-Schedule/standard/${stdId}/`,
    page: pageIndex,
    pageCount: dataCount,
  });
  const { standardDetailName, standardStartDate, standardEndDate } =
    useGetStandardDetail({ id: stdId });
  const [showExport, setShowExport] = useState(false);
  const [showImport, setShowImport] = useState(false);

  function clearFilter() {
    getData();
    navigate(".", { replace: true, state: { statusFilter: null } });
  }

  return (
    <>
      <ViewTableIndex
        label="Audit Schedule"
        menu="Activity"
        standardName={standardName}
        total={totalCount}
        setDataCount={setDataCount}
        dataCount={dataCount}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        setOpenForm={setShowMyModal}
        Access="activity_create"
        header={header}
        isLoading={isLoading}
        ExportAccess="export"
        ExportFunction={() => setShowExport(true)}
        hasExport={true}
        ImportAccess="import"
        ImportFunction={() => setShowImport(true)}
        hasImport={true}
        hasFilter={true}
        filterValue={statusFilter}
        clearFunction={clearFilter}
      >
        <>
          {data &&
            data?.map((data, i) => (
              <tr
                className="odd:bg-tableodd even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1"
                key={i}
              >
                <td className="px-2 py-1 text-gray-900 whitespace-nowrap text-center w-[5%] capitalize">
                  {data.serial_number || "#"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[9%] capitalize ">
                  {data?.reference_number || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.performed_by || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.process_description || "-"}
                </td>                
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.audit_description || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.auditee || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.start_date && (NuDateFormat({
                              value: data?.start_date,
                              format: "DD-MMM-yyyy",
                            })) || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.end_date && (NuDateFormat({
                              value: data?.end_date,
                              format: "DD-MMM-yyyy",
                            })) || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[9%] capitalize ">
                  {data?.result || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[10%] capitalize ">
                  {data?.status || "-"}
                </td>
                <td className="px-2 py-1 text-center text-gray-900 w-[4%] capitalize flex justify-center items-center">
                  {data?.attachment?.length > 0 && <PaperClip />}
                </td>
                <td className="px-2 py-1 w-[3%] flex justify-center items-center">
                  <ViewMore
                    data={data}
                    metaData={dropDownValue}
                    satusData={statusValue}
                    fetcher={getData}
                    id={stdId}
                  />
                </td>
              </tr>
            ))}
        </>
      </ViewTableIndex>
      <CreateOrEdit
        visible={showMyModal}
        onClose={handleOnClose}
        refreshData={getData}
        metaData={dropDownValue}
        satusData={statusValue}
        id={stdId}
      />
      <CommonXlsExport
        id={stdId}
        path={`audit_schedule`}
        name={`${standardDetailName} Audit Schedule ${
          standardStartDate &&
          NuDateFormat({ value: standardStartDate, format: "MMM-YYYY" })
        } ${standardEndDate && "to"} ${
          standardEndDate &&
          NuDateFormat({ value: standardEndDate, format: "MMM-YYYY" })
        }`}
        visible={showExport}
        onClose={() => {
          setShowExport(false);
        }}
      />

      <CommonImport
        url={`/Audit-Schedule/standard/${stdId}/Import`}
        refreshData={getData}
        visible={showImport}
        onClose={() => setShowImport(false)}
        hasRemoveApproval={true}
        moduleId={ModelId}
        standardId={stdId}
      />
    </>
  );
}

export default AuditScheduleIndex;

const header = [
  {
    headone: <span>Sl&nbsp;No.</span>,
    width: "w-[5%]",
  },
  {
    headone: "Ref Number",
    width: "w-[9%]",
  },
  {
    headone: "Performed By",
    width: "w-[10%]",
  },
  {
    headone: "Process Description",
    width: "w-[10%]",

  },
  {
    headone: "Audit Description",
    width: "w-[10%]",
  },
  {
    headone: "Auditee",
    width: "w-[10%]",
  },
  {
    headone: "Start Date",
    width: "w-[10%]",
  },
  {
    headone: "End Date",
    width: "w-[10%]",
  },
  {
    headone: "Results",
    width: "w-[9%]",
  },
  {
    headone: "Status",
    width: "w-[10%]",
  },
  {
    headone: "Artefact",
    width: "w-[4%]",
  },
  {
    headone:"",
    width: "w-[3%]",
  },
];
